import { Box, Button, Text } from '@usap/uicomponents'
import styled from 'styled-components'

export const OuterFormBox = styled(Box)`
  flex-direction: row
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    flex-direction: column;
  }
`

export const LowPriceOuterBox = styled(Box)`
  margin-bottom: 20px;
  padding-bottom: 16px;
  color: #333333;
  height: 32px;
`

export const LowPriceInnerBox = styled(Box)`
  padding-bottom: 16px;
`

export const LowPriceRequiredText = styled(Text)`
  color: #333333;
  font-size: 14px;
`

export const LowPriceAsterisk = styled(Text)`
  color: #fc7e00
`

export const ThemeLowPriceOuterBox = styled(Box)`
  margin-bottom: 24px;
`

export const ThemeLowPriceHeadingBox = styled(Box)`
  margin: 16px 0;
  background-color: #f5f5f5;
  padding: 16px;
  height: 58px;
`

export const InfoHeadingContainer = styled(Box)`
  margin-bottom: 20px;
  background-color: #f5f5f5;
  padding: 16px;
  height: 58px;
`

export const CaptchaContainer = styled(Box)`
  margin-bottom: 10px;
`
export const CaptchaWrapper = styled(Box)`
  width: 576px;
  padding-bottom: 16px;
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    width: 100%;
  }
`
export const CaptchaOuterBox = styled(Box)`
  width: 576px;
  align-self: flex-start;
  ${({ theme }) => theme.mediaQuery.down('tablet-landscape')} {
    width: 100%;
  }
`

export const CaptchaInnerBox = styled(Box)`
  align-self: flex-start;
  align-items: flex-start;
  padding-bottom: 16px;
`

export const SubmitButton = styled(Button)`
  height: 52px;
  width: 328px;
`
